import { Button as ADButton } from "antd";
/**
 * @param {import('antd').ButtonProps} props
 */
const Button = (props) => {
  return <ADButton {...props} />;
};

export default Button;
